<p-checkbox
  (ngModelChange)="handleSelectionChange($event)"
  [binary]="true"
  [disabled]="disabled"
  [ngModel]="isChecked$ | async" />
